import React, {useEffect} from 'react';
import {detectAnyAdblocker} from 'just-detect-adblock';

import Header from './partials/Header';
import Introduction from './components/Introduction';
import Introduction2 from './components/Introduction2';
import Section01 from './components/Section01';
import Section02 from './components/Section02';
import Section03 from './components/Section03';
import Sources from './components/Sources';
import SizeSVG from './SizeSVG';
import Footer from './partials/Footer';
import isMobile from 'ismobilejs';

function App() {
    useEffect(() => {
        detectAnyAdblocker().then(detected => {
            if (detected) {
                const adButtons = document.querySelectorAll('[href*="https://ad.doubleclick.net/"]');
                const newUrl = 'https://go.etoro.com/fr/smart-portfolios/tech?utm_medium=Content%20Partnerships&utm_source=109189&utm_content=20139&utm_serial=343846156&utm_campaign=343846156&utm_term=&Source=Media&dclid=CNr3y7HDoPoCFVBGHQkdqbwH8A';

                Object.values(adButtons).map(button => button.href = newUrl);
            }
        });
    }, []);

    useEffect(() => {
        if (!isMobile().phone && window.outerWidth > 1000) {
            const svgs = document.querySelectorAll('svg:not(.no--resize)');

            Object.values(svgs).map(svg => SizeSVG(svg));
        }
    }, []);

    return (
        <main className="App">
            <Header/>
            <Introduction/>
            <Introduction2/>
            <Section01/>
            <Section02/>
            <Section03/>
            <Sources/>
            <Footer/>
        </main>
    );
}

export default App;
